import useUser from "@User/hooks/useUser";

export default function useIsDebugUser() {
    const user = useUser()
    const debugUsers = [2552, 822554]
    return debugUsers.includes(user?.id)
}